export default "__VITE_ASSET__BjNRcl0k__"